module.exports = __webpack_public_path__ + "static/media/man-relaxed.5556dabc.svg";